<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <i class="fa fa-bug"></i> {{ $t('faultDetectionIP') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab>
            <template slot="title">
              {{ $t('await') }}
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
              <small v-else>({{ count[0] }})</small>
            </template>
          </b-tab>
          <b-tab>
            <template slot="title">
              {{ $t('locked') }}
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
              <small v-else>({{ count[1] }})</small>
            </template>
          </b-tab>
          <b-tab>
            <template slot="title">
              {{ $t('skip') }}
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
              <small v-else>({{ count[2] }})</small>
            </template>
          </b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <client-select :model="filterFormModel" attribute="client" class="mr-1 mb-1" @input="load"></client-select>
            <admin-user-select class="mr-1 mb-1" :model="filterFormModel" attribute="sales"
                               :isFilter="true" :place-holder="$t('chooseSales')" not-updated-select>
            </admin-user-select>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12">
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('listSummary', [firstItemOfPage, lastItemOfPage, new Intl.NumberFormat().format(itemCount)]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                            @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('client') }}</div>
            <div class="col-lg-3">{{ $t('agent') }}</div>
            <div class="col-lg-4">{{ $t('hangupCause') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              {{ item.client.companyName }} ({{ item.client.domain }})
              <div>
                <b>{{ $t('createTime') }}: </b>
                <span v-if="item.client">{{ item.client.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <span v-if="!item.client.active" class="badge badge-danger">{{ $t('locked') }}</span>
            </div>
            <div class="col-lg-3">
              <div>
                <b>{{ $t('sales') }}: </b>
                <span v-if="item.sales">{{ item.sales.name }}</span>
                <span v-else class="text-secondary small">{{ $t('unknown') }}</span>
              </div>
            </div>
            <div class="col-lg-4">
              <div v-if="item.approveTime">
                <b>{{ $t('approveTime') }}: </b> {{ item.approveTime | moment('DD/MM/YYYY HH:mm:ss') }}
                <span v-if="item.approveBy" class="ml-2"><b>{{ $t('by') }}: </b> {{ item.approveBy.name }}</span>
              </div>
              <div v-if="item.cancelTime && filterFormModel.status !== 0">
                <b>{{ $t('cancelTime') }}: </b> {{ item.cancelTime | moment('DD/MM/YYYY HH:mm:ss') }}
                <span v-if="item.cancelBy" class="ml-2"><b>{{ $t('by') }}: </b> {{ item.cancelBy.name }}</span>
              </div>
              <div v-if="!item.approveTime && !item.cancelTime" class="text-secondary small">{{ $t('await') }}</div>
            </div>
            <div class="col-lg-2">
              <div class="d-flex justify-content-end">
                <i-p-users :model="item"></i-p-users>
                <call-detail :id="item._id" :model="item"></call-detail>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('listSummary', [firstItemOfPage, lastItemOfPage, new Intl.NumberFormat().format(itemCount)]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import ClientSelect from "../../components/ClientSelect";
import CallDetail from "./IPCallDetail.vue";
import IPUsers from "./IPUsers.vue";
import AdminUserSelect from "@/components/AdminUserSelect.vue";

export default {
  components: {AdminUserSelect, CallDetail, IPUsers, ClientSelect},
  mixins: [List, CRUD],
  data: function () {
    return {
      saveLoading: false,
      service: '/fault-detection-ip',
      reloadBus: "faultDetectionIP",
      afterLoad: () => {
        this.getCount();
      },
      defaultFilterFormModel: {
        status: 0,
        sales: null,
        account: null,
        client: null
      },
      count: {},
      countLoading: false,
      firstItemOfPage: 0,
      lastItemOfPage: 0,
    }
  },
  i18n: {
    messages: {
      en: {
        faultDetectionIP: "Suspicious customers",
        await: "Await",
        number: 'Number',
        ext: 'Extension',
        contact: 'Contact',
        ticket: 'Ticket',
        user: 'Agent',
        incoming: 'Incoming',
        outgoing: 'Outgoing',
        local: 'Internal',
        from: 'From',
        to: 'To',
        callDetail: 'Call detail',
        direction: 'Direction',
        duration: 'Duration',
        billDuration: 'Talk duration',
        startTime: 'Start',
        answerTime: 'Answer',
        endTime: 'End',
        hangupCause: 'End status',
        NORMAL_CLEARING: 'Successfully',
        USER_BUSY: 'Busy',
        ORIGINATOR_CANCEL: 'Caller cancel',
        NO_USER_RESPONSE: 'No answer',
        listenRecording: 'Recording',
        createContact: 'Create new contact',
        createTicket: 'Create new ticket',
        addToTicket: 'Add to existing ticket',
        content: 'Content',
        fail: 'Fail to connect',
        noTranscript: 'No transcript recorded',
        toNumber: 'To number',
        fromNumber: 'From number',
        allCallDirection: 'Call direction: All',
        allCallStatus: 'Status: All',
        audioQuality: 'Audio quality',
        na: 'Not available',
        missCall: 'Miss call',
        outboundSuccess: 'Outbound success',
        outboundFailed: 'Outbound failed',
        skip: "Skip",
        lockClient: "Are you sure this customer is violating policy?",
        deleteConfirm: "Confirm the customer is not infringing",
        lockSuccess: "Xác nhận khoá khách hàng, gửi email thông báo và thông báo đến admin",
        cancelTime: "Cancel time",
        by: "by",
        chooseSales: "Choose sales",
        chooseAccount: "Choose account",
        account: "Account",
        agent: "Agent",
        listSummary: "Showing {0}-{1}/{2} result(s)",
      },
      vi: {
        faultDetectionIP: "Khách hàng nghi ngờ",
        await: "Chờ kiểm tra",
        number: 'Số',
        ext: 'Nhánh',
        contact: 'Khách',
        ticket: 'Ticket',
        user: 'Nhân viên',
        incoming: 'Gọi vào',
        outgoing: 'Gọi ra',
        local: 'Gọi nội bộ',
        from: 'Gọi từ',
        to: 'Gọi đến',
        callDetail: 'Chi tiết cuộc gọi',
        direction: 'Hướng gọi',
        duration: 'Tổng thời gian',
        billDuration: 'Đàm thoại',
        startTime: 'Bắt đầu',
        answerTime: 'Trả lời',
        endTime: 'Kết thúc',
        hangupCause: 'Kết quả',
        NORMAL_CLEARING: 'Thành công',
        USER_BUSY: 'Máy bận',
        ORIGINATOR_CANCEL: 'Người gọi dừng',
        NO_USER_RESPONSE: 'Không nghe máy',
        listenRecording: 'Nghe ghi âm',
        createContact: 'Tạo KH mới',
        createTicket: 'Tạo ticket mới',
        addToTicket: 'Thêm vào ticket',
        content: 'Nội dung',
        fail: 'Kết nối thất bại',
        noTranscript: 'Không ghi nhận được nội dung',
        toNumber: 'Gọi ra đến số',
        fromNumber: 'Gọi ra từ số',
        allCallDirection: 'Hướng gọi: Tất cả',
        allCallStatus: 'Trạng thái: Tất cả',
        audioQuality: 'Chất lượng gọi',
        na: 'Không có thông tin',
        missCall: 'Gọi nhỡ',
        outboundSuccess: 'Gọi ra thành công',
        outboundFailed: 'Gọi ra thất bại',
        skip: "Bỏ qua",
        lockClient: "Bạn chắc chắc xác định khách hàng này đang vi phạm chính sách?",
        deleteConfirm: "Xác nhận khách hàng không vi pham, bỏ qua nghi ngờ?",
        lockSuccess: "Xác nhận khoá khách hàng, gửi email thông báo và thông báo đến admin",
        cancelTime: "Bỏ qua lúc",
        by: "bởi",
        chooseSales: "Chọn sales",
        chooseAccount: "Chọn chăm sóc",
        account: "Chăm sóc",
        agent: "Nhân viên",
        listSummary: "Đang xem {0}-{1}/{2} kết quả",
      }
    }
  },
  methods: {
    getCount() {
      this.countLoading = true
      this.$service.get(this.service + '/count', {params: this.filterFormModel})
          .then(response => {
            this.count = response.data;
          })
          .catch(() => {
            this.count = {};
          })
          .finally(() => {
            this.countLoading = false;
          });
    },
    apply: function (data) {
      this.items = data.docs;
      this.itemCount = data.totalDocs;
      this.firstItemOfPage = this.itemCount > 0 ? (this.filterFormModel.page - 1) * this.filterFormModel.pageSize + 1 : 0;
      this.lastItemOfPage = (this.filterFormModel.page - 1) * this.filterFormModel.pageSize + this.items.length;
    },
    reset: function () {
      this.filterFormModel = {}
      Object.assign(this.filterFormModel, this.defaultFilterFormModel)
      this.load()
    },
  },
};
</script>